import { InjectionToken } from '@angular/core';

export const APP_TEMPLATE_CONFIG = new InjectionToken<any>('APP_CONFIG');
